import { Injectable } from '@angular/core';

import { Subject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ModalCreditService {
    private response = new Subject<boolean>();
    private data = new Subject<any>();

    get(): Observable<boolean> {
        return this.response.asObservable();
    }

    create(data?: any): Observable<boolean> {
        this.setData(data);

        return this.get();
    }

    ok(): void {
        this.response.next(true);
    }

    ko(): void {
        this.response.next(false);
    }

    getData(): Observable<any> {
        return this.data.asObservable();
    }

    setData(data?: any): void {
        this.data.next(data);
    }
}
